export const environment = {
  production: true,
  baseURL: "https://sistema.gobox.app.br/",
  headers: {
    Auth: "Basic f28aa34cb3c40d3bc5b888edba9e61d6a0fccc36e6830ccef16aaaaaa7c7",
  },
};
